import { render } from "./about.vue?vue&type=template&id=327c94fc&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=327c94fc&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/huwei-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327c94fc"]])

export default __exports__